<template lang="pug">
.medium.row
  .cell.thumbnail(@click='editMedium(exception.Medium)')
    img.thumb-image(v-if='showThumnail', :src="getMediumThumbnailPath(medium)")
    MediumIcon.type-icon(v-if='showThumnail', :medium='medium')
  .cell.text-data(@click='editPlaylist(playlist.id)')
    span.medium-name {{ showThumnail ? medium.name : '' }} -
    span &nbsp;{{ $t('exception set in') }}
    span.playlist.warning &nbsp;{{ playlist.name }}
  .cell.exceptions(v-if='hasPlayers && !loading')
    p(v-for ='exceptionFor in JSON.parse(exception[type])')
      span.device {{ fullNameOfDesktopPlaylistById(exceptionFor) }} &nbsp;
  .cell.exceptions.warning(v-if='!hasPlayers && !loading')
    p
      span.device No player uses medium in this context &nbsp;
  .cell.exceptions.warning(v-if='loading')
    p
      span.device ...loading &nbsp;
</template>

<script>
import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'
import mediaUtils from '../Common/mediaUtils.mixin'
import MediumIcon from './../Common/MediumIcon'

export default {
  props: ['exception', 'type', 'showThumnail'],
  mixins: [textUtils, mediaUtils],
  components: {
    MediumIcon
  },
  watch: {
    foo: async function (newVal, oldVal) {
    }
  },
  async created () {
    this.loading = true
    let playlistsFullPath = (await Vue.axios.post('medium/findPlaylistsAffectedFullPath', { 'Medium': this.playlist.id })).data.occurrences
    let filteredLocalPlaylists = playlistsFullPath.filter(plfp => plfp.type === 'PlayListDesktop')
    this.hasPlayers = filteredLocalPlaylists.length > 0
    this.loading = false
  },
  data () {
    return {
      hasPlayers: false,
      loading: true
    }
  },
  methods: {
    editMedium (mediumId) {
      this.$emit('loadMediumEditor', mediumId)
    },
    editPlaylist (playListId) {
      console.log('loadPlayListEditor', playListId)
      this.$emit('loadPlayListEditor', playListId)
    }
  },
  computed: {
    medium () {
      return this.$store.state.Medium.media_list.find(m => m.id === this.exception.Medium)
    },
    playlist () {
      return this.$store.state.Medium.media_list.find(m => m.id === this.exception.PlayList)
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.medium {
    overflow: hidden;
    max-width: 100%;
    &.row {
      width: 100%;
      border-top: $--border-light;
      display: flex;
      align-items: center;
      .cell {
        &.thumbnail {
        display: flex;
        align-items: center;
        width: 140px;
        height: 70px;
        cursor: zoom-in;
          .thumb-image {
            max-width: 60px;
            max-height: 60px;
            margin: auto;
            font-size: 40px;
            color: $--color-text-secondary;
          }
          .type-icon {
            padding: 10px;
            width: 70px;
          }
        }
        &.text-data {
          font-size: 11px;
          width: 35%;
          overflow: hidden;
          cursor: pointer;
          .medium-name {
            font-weight: bold;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediaExceptionsRow.vue